import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getThumbnailUrl } from '../utils/imageLoader'
import './Eshop.scss'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import renderOptions from '../utils/textRenderOption'

import Lenis from 'lenis';
import { motion, AnimatePresence } from 'framer-motion'


const EshopCategory = ({ products = [], category, eshopInfo = null }) => {
    const navigate = useNavigate()
    const [hoveredProductId, setHoveredProductId] = useState(null)

    const filteredProducts = products.filter((product) =>
        Array.isArray(product.categorie) && product.categorie.includes(category)
    )

    // Lenis smooth scrolling (match other pages)
    useEffect(() => {
        const lenis = new Lenis({
            smoothWheel: true,
            wheelMultiplier: 0.8,
            touchMultiplier: 0.8,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className='eshop'>
            <div className='eshopInfo'>
                {eshopInfo
                    && documentToReactComponents(eshopInfo, renderOptions)
                }
            </div>

            <div className='gridContainer'>
                {filteredProducts.map((product) => {
                    const caption = (product.caption || '').trim()
                    const captionParts = caption ? caption.split(' — ').map(p => p.trim()).filter(Boolean) : []
                    let price = (product.prix || '').toString().trim()
                    if (!price) {
                        const euroPart = captionParts.find(p => p.includes('€'))
                        if (euroPart) price = euroPart
                        else if (captionParts.length) price = captionParts[captionParts.length - 1]
                        else {
                            const m = caption.match(/(\d+[.,]?\d*)\s*€|€\s*(\d+[.,]?\d*)/)
                            if (m) price = (m[1] || m[2]) + ' €'
                        }
                    }
                    return (
                        <div
                            key={product.id}
                            className='productCard'
                        >
                            <div
                                className='imageWrapper'
                                onClick={() => product.path && navigate(product.path)}
                            >
                                <img
                                    src={getThumbnailUrl(product.asset) || product.src}
                                    alt={product.titre || 'Artwork'}
                                />
                            </div>
                            <div
                                className='productInfo'
                                onMouseEnter={() => setHoveredProductId(product.id)}
                                onMouseLeave={() => setHoveredProductId(null)}
                                onClick={() => product.path && navigate(product.path)}
                            >
                                <p className='titre'>{product.titre}</p>
                                <p className='taille'>
                                    {(product.caption || '').split(' — ').find(part => part.includes('cm')) || ''}

                                </p>

                                <p className='prix'>{price} <span className={`stockDot ${product.stock ? 'inStock' : 'outStock'}`} /></p>

                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default EshopCategory
